import { useEffect, useState } from "react";
import { footerData } from "../contentData/layout-data/LayoutData";

function Footer() {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(footerData);
  }, []);

  return (
    <footer>
      <div className="bg-secondary py-10 xl:py-10">
        <div className="container">
          <div className="flex flex-col sm:flex-row gap-3 xl:gap-0">
            <div className="flex flex-col gap-7 xl:max-w-2xl w-full">
              {data?.tagline && (
                <img className="h-[90px] w-[90px] md:h-[160px] md:w-[160px]" src={data?.tagline}/>
              )}
              <div className="flex flex-col gap-2 ">
                {data?.info?.map((value, index) => {
                  return (
                    <div key={index}>
                      <a href={value.href} className="flex gap-2 text-[12px] sm:text-[15px]">
                        {/* <img src={value.icon} alt="icon" /> */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#fff6e2" d="M4.616 19q-.691 0-1.153-.462T3 17.384V6.616q0-.691.463-1.153T4.615 5h14.77q.69 0 1.152.463T21 6.616v10.769q0 .69-.463 1.153T19.385 19zM12 11.96q.125 0 .234-.038q.108-.038.214-.093l7.229-4.733q.142-.086.185-.235t-.016-.297q-.038-.193-.252-.28q-.213-.086-.413.035L12 11L4.82 6.32q-.2-.122-.404-.052t-.262.276q-.058.154-.015.313t.184.24l7.229 4.732q.106.055.214.093q.109.037.234.037"/></svg>
                        <span className="text-white hover:text-primary text-[12px] sm:text-[15px]">{value.link}</span>
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 w-full">
              {/* <ul className="flex flex-col gap-1.5">
                {data?.links?.map((value, index) => {
                  return (
                    <li key={index}>
                      <a href={value.href} className="text-lg text-white hover:text-primary">
                        {value.name}
                      </a>
                    </li>
                  );
                })}
              </ul> */}

              <ul className="flex flex-col">
                {data?.socialLinks?.map((value, index) => {
                  return (
                    <li key={index}>
                      <a href={value.href} className="text-[12px] sm:text-[15px] text-white hover:text-primary">
                        {value.name}
                      </a>
                    </li>
                  );
                })}
              </ul>

              <div className="flex md:justify-end xl:col-span-2">
                <p className="text-white/70 pt-[10px] text-[12px] sm:text-[15px] max-w-96">
                  {data?.copyright}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;